<template>
    <span class="highlight-text">
        <span v-for="(token, index) of tokens" :key="index" :class="token[0]"
        >{{ token[1] }}</span>
    </span>
</template>

<script>
export default {
    props: {
        text: String,
        keyword: String,
    },
    computed: {
        tokens() {
            const plains = this.text.split(this.keyword);
            const tokens = [];
            plains.forEach((e) => {
                tokens.push([ "plain", e ]);
                tokens.push([ "keyword", this.keyword ]);
            });
            tokens.pop();
            return tokens;
        }
    }
}
</script>

<style lang="less" scoped>
.plain {

}
.keyword {
    color: red;
}
</style>